
<span class="PGListEditor">
    <!-- TODO: gestire la ricerca -->
    @if (viewAs == null || isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (viewAs != null && !isLoading) {
        <div class="PGListEditor-Selected">
            @for (selected of selectedOptions; track selected; let i = $index) {
                @if (!isOptionIgnored(selected)) {
                    <div class="badge bg-light">
                        @if (order  && !readonly) {
                            <button type="button" class="btn btn-light" [disabled]="i == 0" (click)="moveSelectedOption(i, -1)"
                                [attr.aria-label]="'pg-list-editor.a11y.move-left' | locTranslate">
                                <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                            </button>
                        }
                        <span>{{selected.text}}</span>
                        @if (!readonly) {
                            <app-pg-confirm-action (confirmed)="deselectOption(selected)">
                                <button type="button" class="btn btn-light text-danger"
                                    [attr.aria-label]="'pg-list-editor.a11y.remove' | locTranslate">
                                    <i class="fa-regular fa-times" aria-hidden="true"></i>
                                </button>
                            </app-pg-confirm-action>
                        }
                        @if (order && !readonly) {
                            <button type="button" class="btn btn-light" [disabled]="i == selectedOptions.length - 1" (click)="moveSelectedOption(i, 1)"
                                [attr.aria-label]="'pg-list-editor.a11y.move-right' | locTranslate">
                                <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                            </button>
                        }
                    </div>
                }
            }
            @if (getVisibleOptions(); as visibleOptions) {
                <div class="PGListEditor-Add" ngbDropdown [autoClose]="false">
                    <button type="button" ngbDropdownAnchor class="btn btn-light text-primary" [disabled]="readonly" (click)="clickFocus($event)"
                        [attr.aria-label]="'pg-list-editor.a11y.add' | locTranslate">
                        <i class="fa-regular fa-plus" aria-hidden="true"></i>
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu PGSelect-Select-Dropdown" [appPgAnimations]="isDropdownClosing ? 'FadeOut' : 'FadeIn'">
                        @if (hasSearch) {
                            <input
                                class="form-control PGSelect-Select-Dropdown-Search" placeholder="{{ 'pg-select.search' | locTranslate }}"
                                [attr.aria-label]="'pg-select.search' | locTranslate"
                                [readonly]="readonly" [tabIndex]="!hasSearch ? -1 : null" [(ngModel)]="search"
                                (click)="$event.stopPropagation()"
                                (focus)="onInputFocus()" (focusout)="onInputBlur()" (keypress)="onKeyPress($event)"/>
                        }
                        <span class="PGSelect-Select-Dropdown-Options">
                            @if (isDropdownLoading) {
                                <app-pg-loading pgAnimations="FadeIn" [isOverlay]="true"></app-pg-loading>
                            }
                            <!-- NB: sulle options ho usato il mousedown come evento perché il click dava problemi "strani" -->
                            @if (visibleOptions.length == 0) {
                                <div class="dropdown-item disabled">
                                    @if (showSearchMin()) {
                                        {{ 'pg-select.search-min' | locTranslate:'min':searchMin }}
                                    }
                                    @if (!showSearchMin()) {
                                        {{ 'pg-select.no-result' | locTranslate }}
                                    }
                                </div>
                            }
                            @for (option of visibleOptions; track option; let i = $index) {
                                @if (showCategoryBefore(i); as category) {
                                    <div class="PGSelect-Select-Dropdown-Options-Category">{{category}}</div>
                                }
                                <div class="dropdown-item {{isOptionDisabled(option) ? 'disabled' : ''}}"
                                    (mousedown)="selectOption(option)">
                                    <span [innerHTML]="option.view != null ? option.view : option.text"></span>
                                </div>
                            }
                            @if (isIncomplete) {
                                <div class="dropdown-item disabled">...</div>
                            }
                        </span>
                    </div>
                </div>
            }
        </div>
    }
</span>
